export default "__VITE_ASSET__8dee04ed__"